
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton as singleton_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import React from "react";

function radioButton(id, group, props) {
    let elems;
    return reactElement("div", createObj(singleton_1((elems = [reactElement("input", createObj(toList(delay(() => append(singleton(["className", join(" ", ["peer", "cursor-pointer", "accent-primary", "disabled:cursor-not-allowed", "disabled:opacity-50"])]), delay(() => append(singleton(["type", "radio"]), delay(() => append(singleton(["id", id]), delay(() => {
        let matchValue;
        return append((matchValue = group, (matchValue == null) ? (empty()) : singleton(["name", matchValue])), delay(() => append(singleton(["checked", props.Selected]), delay(() => append(singleton(["onChange", (ev) => {
            props.OnSelect(ev.target.checked);
        }]), delay(() => singleton(["disabled", props.ComponentState === "disabled"])))))));
    })))))))))), reactElement("label", {
        className: join(" ", ["ml-2", "text-sm", "peer-disabled:text-text-muted", "peer-disabled:cursor-not-allowed"]),
        children: props.Label,
        htmlFor: id,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function RadioButton(props) {
    return radioButton(concat("radio-button-", ...props.Label), undefined, props);
}

export function RadioButtonInGroup(props) {
    return radioButton(concat("radio-button-", props.Group, "-", ...props.Label), props.Group, {
        ComponentState: props.ComponentState,
        Label: props.Label,
        OnSelect: props.OnSelect,
        Selected: props.Selected,
    });
}

